var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3994 18.5694L20.3085 18.2165C19.9451 18.1738 19.5767 18.214 19.2311 18.3342C18.8854 18.4543 18.5715 18.6512 18.3129 18.9101L16.0738 21.1491C12.6196 19.3919 9.81191 16.5842 8.05467 13.13L10.3059 10.8788C10.8291 10.3555 11.0847 9.62538 10.9995 8.88309L10.6466 5.81658C10.5779 5.22286 10.2931 4.67519 9.84647 4.27796C9.39987 3.88074 8.82272 3.66175 8.22503 3.66272H6.11985C4.74479 3.66272 3.60093 4.80658 3.68611 6.18164C4.33105 16.5737 12.6423 24.8728 23.0222 25.5177C24.3972 25.6029 25.5411 24.459 25.5411 23.084V20.9788C25.5532 19.7497 24.6284 18.7154 23.3994 18.5694Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.ad7df7d99ed2d3e2b18f9a8741fb79ad.svg";
export { ForwardRef as ReactComponent };